<script lang="ts" setup>
import { computed, onMounted, PropType, ref } from "vue";
import { TaskModel } from "@/components/tasks-kanban/models";
import { TaskParameterTypeEnum } from "@/components/task-parameter";
import TagParameter from "@/components/task-parameter/components/tag-parameter.vue";
import PriorityParameter from "@/components/task-parameter/components/priority-parameter.vue";
import StatusParameter from "@/components/task-parameter/components/status-parameter.vue";
import { OptionItemModel } from "../../../models";

/**Параметры */
const props = defineProps({
  /**Задача */
  item: { type: Object as PropType<OptionItemModel> },
  /**Тип */
  type: { type: Object as PropType<TaskParameterTypeEnum> },
});

/**Компонент для отображения параметра */
const parameterComponent = computed(() => {
  switch (props.type) {
    case TaskParameterTypeEnum.Status:
      return StatusParameter;
    case TaskParameterTypeEnum.Priority:
      return PriorityParameter;
    case TaskParameterTypeEnum.Tag:
      return TagParameter;
  }
});

/**Ссылка на дом элемента фильтра */
const $itemFilter = ref<InstanceType<typeof HTMLElement>>();

/**После рендера компонента */
onMounted(() => {
  if (!props.item.Width) props.item.Width = $itemFilter.value.offsetWidth;
});
</script>
<template>
  <div ref="$itemFilter">
    <component :is="parameterComponent" :data="item" hideRemove preview />
  </div>
</template>
